<template>
  <div id="selectSettings" class="col-lg-4 col-sm-12 mt-4">
    <div
      class="baseline_box"
      id="baseline_box1"
      @click="changeborder1(true)"
      @blur="changeborder1(false)"
    >
      <b-form-select
        id="SelectCategoria"
        class="col-sm-12 mt-4 SelectCategoria"
        v-model="selected2"
        :options="options"
        @change="change"
      ></b-form-select>

      <label class="label-helper" for="SelectCategoria">Categoría</label>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "SelectSettings",
  data() {
    return {
      cambio: false,
      selected2: null,
      options: [
        { value: null, text: "Elija una categoría" },
        { value: "bancos", text: "Bancos" },
        { value: "lineas-negocios", text: "Lineas de Negocios" },
        { value: "zonas", text: "Zonas" },
        { value: "escenarios", text: "Escenarios" },
        { value: "bolsas-apoyo", text: "Bolsas de Apoyo" },
        { value: "punto-ventas", text: "Punto de ventas" },
        { value: "grupo-cargos", text: "Grupo de Cargos" },
        { value: "cargos", text: "Cargos" },
        { value: "empleados", text: "Empleados" },
      ],
    };
  },
  methods: {
    ...mapActions("modPlatformSettings", ["actSelected"]),

    change() {
      this.actSelected(this.selected2);
    },

    changeborder1(cambio) {
      if (cambio) {
        document.getElementById("baseline_box1").style.borderColor = "#5D5FEF";
      } else {
        document.getElementById("baseline_box1").style.borderColor = "#78909C";
      }
    },
  },
};
</script>

<style lang="scss">
#selectSettings {
  .SelectCategoria {
    border: none !important;

    position: static;
    //width: 412px;
    height: 28px;
    left: calc(50% - 412px / 2);
    top: calc(50% - 28px / 2);
    background: #ffffff;
    /* body regular */
    font-family: Ubuntu;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;

    /* content/03 */
    color: #78909c;
    /* Inside auto layout */
    align-self: stretch;
    flex-grow: 1;
    //margin: 8px;
    border: 0;
    &:focus,
    &:active {
      outline: 0;
      border: 0;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      box-shadow: none;
    }
  }
  .SelectCategoria:valid + .label-helper {
    color: #78909c;
    opacity: 1;
  }
  .SelectCategoria:focus + .label-helper,
  .SelectCategoria:active + .label-helper {
    color: #5d5fef;
    opacity: 1;
  }

  .baseline_box input {
    width: 390px !important;
  }

  .baseline_box {
    position: relative;
    margin-top: 8px;
    margin-bottom: 8px;
    /* content/00 */
    background: #ffffff;
    /* content/01 */
    border: 1px solid #eceff1;
    box-sizing: border-box;
    border-radius: 8px;
    label {
      /* label */
      position: absolute;
      left: 4px;
      top: -8px;
      line-height: 1;
      font-weight: bold;
      padding: 4 6px;
      display: none;

      /* label regular */
      font-family: Ubuntu;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      /* identical to box height, or 133% */
      display: flex;
      align-items: center;
      /* content/02 */
      color: #cfd8dc;
      background: #ffffff;
      /* Inside auto layout */
      flex: none;
      order: 0;
      flex-grow: 0;
      margin: 0px 4px;
      padding: 0px 4px;
    }
    input {
      position: static;
      width: 412px;
      height: 28px;
      left: calc(50% - 412px / 2);
      top: calc(50% - 28px / 2);
      background: #ffffff;
      /* body regular */
      font-family: Ubuntu;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 28px;
      /* content/03 */
      color: #b0bec5;

      margin: 8px;
      border: 0;
      &:focus,
      &:active {
        outline: 0;
        border: 0;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        box-shadow: none;
      }
    }
  }
}
</style>